module.exports = __webpack_public_path__ + "img/arrow-right-white.c19af021.svg";